module.exports = __webpack_public_path__ + "static/img/成果对接.b4fc849d.png";